const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    notation: 'compact',
    compactDisplay: 'long',
})

export const checkAmount = (amount) => {
    return (amount === null || amount === 0 || amount < 10) ? true : false;
}

export const numberFormatter = (num) => {
    return formatter.format(num);
}

export const indNumberFormat = (num) => {
    return new Intl.NumberFormat('en-IN').format(num)
}